import { updateDeviceTypesFromEvent } from 'services/devices/devices.service';
import { integrationsApi } from './integrations.api';

export const updateSystemFromEvent = (dispatch, system) => {
  if (!system?.id) return;

  dispatch(
    integrationsApi.util.updateQueryData(
      integrationsApi.endpoints.fusionGetIntegrations.name,
      undefined,
      (draft) => {
        const indexOfSystemToUpdate = draft.findIndex(
          (integration) => integration.id === system.id,
        );

        if (indexOfSystemToUpdate >= 0) {
          draft[indexOfSystemToUpdate] = {
            ...draft[indexOfSystemToUpdate],
            ...system,
          };
        }
      },
    ),
  );
};

export const addSystemFromEvent = (dispatch, { system, allDeviceTypes }) => {
  if (!system?.id) return;

  dispatch(
    integrationsApi.util.updateQueryData(
      integrationsApi.endpoints.fusionGetIntegrations.name,
      undefined,
      (draft) => {
        const systemExists = draft.some((integration) => integration.id === system.id);

        if (!systemExists) {
          draft.push(system);
        }

        if (allDeviceTypes) {
          updateDeviceTypesFromEvent(dispatch, allDeviceTypes);
        }
      },
    ),
  );
};

export const removeSystemFromEvent = (dispatch, { id }) => {
  if (!id) return;

  dispatch(
    integrationsApi.util.updateQueryData(
      integrationsApi.endpoints.fusionGetIntegrations.name,
      undefined,
      (draft) => {
        const indexOfSystemToRemove = draft.findIndex((integration) => integration.id === id);

        if (indexOfSystemToRemove >= 0) {
          draft.splice(indexOfSystemToRemove, 1); // Starts at the index of the system to remove and removes that 1 item from the array
        }
      },
    ),
  );
};
